export enum GameInstanceRoute {
  gameInstanceList = 'Game Instance List',
  gameInstanceCreate = 'Game Instance Create',
  gameInstanceCreateOrder = 'Game Instance Create Order',
  gameInstanceEdit = 'Game Instance Edit'
}
